import React from 'react';
import { ArrowRight } from 'lucide-react';
import styles from './LandingHero.module.scss';

interface LandingHeroProps {
  onLogin: () => void;
  onRegister: () => void;
  onScrollToServices: () => void;
  isLoading?: boolean;
}

function LandingHero({
  onRegister,
  onScrollToServices,
  isLoading,
}: LandingHeroProps) {
  return (
    <section className={styles.hero} aria-label="Hero">
      <div className={styles.heroInner}>
        <div className={styles.heroContent}>
          <p className={styles.badge}>Simplify Your Work</p>

          <h1 className={styles.heroTitle}>
            One&nbsp;<span className={styles.coreWord}>App</span>.
            <br />
            <span className={styles.totalWord}>Amplify</span>&nbsp;Business.
          </h1>

          <p className={styles.heroSubtitle}>
            Simplify your work, amplify your business. Automate your bookkeeping
            from receipt uploads to auto-generated PFRS-compliant financial
            reports in one workspace.
          </p>

          <div className={styles.heroActions}>
            <button
              className={styles.btnPrimary}
              onClick={onScrollToServices}
              disabled={isLoading}
              type="button"
            >
              Explore solutions
            </button>
            <button
              className={styles.btnSecondary}
              onClick={onRegister}
              disabled={isLoading}
              type="button"
            >
              Visit the Hub
              <ArrowRight size={16} aria-hidden="true" />
            </button>
          </div>

          <div className={styles.trustStats} aria-label="Trust indicators">
            <span>100% PFRS-Aligned</span>
            <span>1 Unified Workspace</span>
            <span>Auto Records Generation</span>
          </div>
        </div>

        <div className={styles.heroVisual} aria-hidden="true">
          <div className={styles.imageFrame}>
            <img
              src={`${import.meta.env.BASE_URL}home-hero-clean.png`}
              alt="Abrasoft Hub desk setup with accounting notebook and dashboard on laptop"
              className={styles.heroImage}
              loading="eager"
            />
          </div>
        </div>
      </div>
      <div className={styles.heroCurve} aria-hidden="true" />
    </section>
  );
}

export default LandingHero;
